import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'

import { guessStringType } from './guessStringType'

/**
 * Guess column type using header title hints first, then sample value.
 * - If header includes "icon" -> Icon
 * - If header includes "date" -> DateTime
 * - Otherwise fallback to value-based guess
 */
export function guessColumnType(headerTitle: string, sampleValue: string): ColumnTypes {
  const header = (headerTitle || '').toString().trim().toLowerCase()

  if (header.includes('icon')) return ColumnTypes.Icon
  if (header.includes('date')) return ColumnTypes.DateTime

  return guessStringType(sampleValue)
}
